import { AgGridReact } from 'ag-grid-react';
import { AllocationReportTableParams } from '../useAllocationReport';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import './styles.pcss';

export const AllocationReportTable: React.FC<AllocationReportTableParams> = ({ gridOptions, onGridReady, rowData }) => {
  return (
    <div className="ag-theme-material allocation-report-table">
      <AgGridReact gridOptions={gridOptions} onGridReady={onGridReady} rowData={rowData} rowHeight={36} />
    </div>
  );
};
